import { render } from "./accessComponent.vue?vue&type=template&id=97198e3c"
import script from "./accessComponent.vue?vue&type=script&lang=js"
export * from "./accessComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__